export function loadImages(images, allowWeserv = true, width = 300) {
    let weserv = allowWeserv ? '//wsrv.nl/?url=' : ''
    if (weserv) { 
        return weserv + images + `&w=${width}`
    } else {
        return images
    }
}